import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import {
  About,
  CTA,
  Features,
  Footer,
  Hero,
  Nav,
  Products,
  Services,
  Team,
  Ticker,
  WhatsAppFloat,
} from './components';

function Home() {
  return (
    <>
      <Nav />
      <Hero />
      <Ticker />
      <About />
      <Services />
      <CTA />
      <Features />
      <Products />
      <Team />
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;